import { FlexContainer } from '@facephi/ui-react';
import { mapMock, sessionsMock, topFiveMock } from '../../api';
import { Devices } from './devices';
import { Filter } from './filter';
import { Map } from './map';
import { Network } from './network';
import { Operations } from './operations';
import { Risk } from './risk';
import { Sessions } from './sessions';
import { LeftColumn, RightColumn, SimpleGraphsContainer } from './Styles';
import { TopFive } from './topFive';

export const Dashboard = () => {
  const mapData = mapMock;
  const sessionsData = sessionsMock;
  const topFiveData = topFiveMock;

  return (
    <FlexContainer
      flexDirection="column"
      rowGap="2.4"
      justifyContent="center"
      style={{ width: '100%' }}
    >
      <Filter />
      <FlexContainer flexDirection="column" rowGap="1.6">
        <FlexContainer flexDirection="row" columnGap="1.6">
          {sessionsData?.map((sessions, index) => (
            <Sessions {...sessions} key={index} />
          ))}
        </FlexContainer>
        <FlexContainer flexDirection="row" columnGap="1.6">
          <LeftColumn flexDirection="column" rowGap="1.6">
            <Operations />
            <Risk />
            <Map data={mapData} />
            <SimpleGraphsContainer flexDirection="row" columnGap="1.6">
              <Network />
              <Devices />
            </SimpleGraphsContainer>
          </LeftColumn>
          <RightColumn flexDirection="column" rowGap="1.6">
            {topFiveData?.map((element, index) => (
              <TopFive title={element.title} data={element.data} key={index} />
            ))}
          </RightColumn>
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};
